import { render, staticRenderFns } from "./productEmpty.vue?vue&type=template&id=66928224&scoped=true&"
var script = {}
import style0 from "./productEmpty.vue?vue&type=style&index=0&id=66928224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66928224",
  null
  
)

export default component.exports